import {Injectable} from '@angular/core';
import {AlertController} from '@ionic/angular';
import {from, Observable} from 'rxjs';
import {AlertOptions} from '@ionic/core';
import {switchMap} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AlertControllerService {
    constructor(private alertController: AlertController) {
    }

    display(alertOptions: AlertOptions): Observable<void> {
        return from(this.alertController.create(alertOptions))
            .pipe(
                switchMap(alert => alert.present().then())
            );
    }

    dismiss(id: string): Promise<boolean> {
        return this.alertController.dismiss(null, null, id);
    }
}
